import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lots: [],
};

export const LotSlice = createSlice({
  name: 'lots',
  initialState,
  reducers: {
    addLot: (state, action) => {
      state.lots.push(action.payload);
    },
    addLots: (state, action) => {
      state.lots = action.payload.lots;
    },
    updateLot: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.lots.findIndex(user => user.id === id);
      if (index !== -1) {
        state.lots[index] = { ...state.lots[index], ...newData };
      }
    },
  },
});

export const { addLot, addLots, updateLot } = LotSlice.actions;

export default LotSlice.reducer;